import { render, staticRenderFns } from "./FreeShiftOffsetEditorDialog.vue?vue&type=template&id=633530c1&scoped=true&lang=pug&"
import script from "./FreeShiftOffsetEditorDialog.vue?vue&type=script&lang=ts&"
export * from "./FreeShiftOffsetEditorDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633530c1",
  null
  
)

export default component.exports